import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

interface NavigationProps {
  scrollToSection: (id: string) => (e: React.MouseEvent) => void;
}

const Navigation: React.FC<NavigationProps> = ({ scrollToSection }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-[#F9F8F4]/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'
        }`}
      >
        <div className="container mx-auto px-6 flex justify-between items-center">
          <div
            className="flex items-center gap-4 cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <div className="w-10 h-10 bg-serchon-gold rounded-lg flex items-center justify-center text-white font-serif font-bold text-2xl shadow-sm">
              溯
            </div>
            <span
              className={`font-serif font-bold text-xl tracking-wide transition-opacity ${
                scrolled ? 'opacity-100' : 'opacity-0 md:opacity-100'
              }`}
            >
              溯玄科技 <span className="font-normal text-stone-500">Serchon</span>
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8 text-sm font-medium tracking-wide text-stone-600">
            <a href="#home" onClick={scrollToSection('home')} className="hover:text-serchon-gold transition-colors cursor-pointer uppercase">
              首页
            </a>
            <a href="#about" onClick={scrollToSection('about')} className="hover:text-serchon-gold transition-colors cursor-pointer uppercase">
              关于我们
            </a>
            <a href="#services" onClick={scrollToSection('services')} className="hover:text-serchon-gold transition-colors cursor-pointer uppercase">
              服务领域
            </a>
            <a href="#technology" onClick={scrollToSection('technology')} className="hover:text-serchon-gold transition-colors cursor-pointer uppercase">
              核心技术
            </a>
            <a href="#advantage" onClick={scrollToSection('advantage')} className="hover:text-serchon-gold transition-colors cursor-pointer uppercase">
              核心优势
            </a>
            <a
              href="#contact"
              onClick={scrollToSection('contact')}
              className="px-5 py-2 bg-stone-900 text-white rounded-full hover:bg-stone-800 transition-colors shadow-sm cursor-pointer"
            >
              联系我们
            </a>
          </div>

          <button className="md:hidden text-stone-900 p-2" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="fixed inset-0 z-40 bg-[#F9F8F4] flex flex-col items-center justify-center gap-8 text-xl font-serif animate-fade-in">
          <a href="#home" onClick={scrollToSection('home')} className="hover:text-serchon-gold transition-colors cursor-pointer uppercase">
            首页
          </a>
          <a href="#about" onClick={scrollToSection('about')} className="hover:text-serchon-gold transition-colors cursor-pointer uppercase">
            关于我们
          </a>
          <a href="#services" onClick={scrollToSection('services')} className="hover:text-serchon-gold transition-colors cursor-pointer uppercase">
            服务领域
          </a>
          <a href="#technology" onClick={scrollToSection('technology')} className="hover:text-serchon-gold transition-colors cursor-pointer uppercase">
            核心技术
          </a>
          <a href="#advantage" onClick={scrollToSection('advantage')} className="hover:text-serchon-gold transition-colors cursor-pointer uppercase">
            核心优势
          </a>
          <a
            href="#contact"
            onClick={scrollToSection('contact')}
            className="px-6 py-3 bg-stone-900 text-white rounded-full shadow-lg cursor-pointer"
          >
            联系我们
          </a>
        </div>
      )}
    </>
  );
};

export default Navigation;
